import { makeStyles, tokens } from '@fluentui/react-components';
import { useT } from '@powerportalspro/react';
import {
  AggregateDataverseChartDataSource,
  QueryAggregate,
  DateGrouping,
  ChartType,
} from '@powerportalspro/react-charts';
import { DataverseChart } from '@powerportalspro/react-fluent';
import { useMemo } from 'react';

// Two line charts over the opportunities' close dates. The first draws one line per year through
// its twelve months — `groupByDateGrouping` makes the months the points along the axis and
// `seriesDateGrouping` a line of each year — so the years can be compared month by month. It keeps
// to this year and the two before it: `filterXml` asks for the opportunities closed since the first
// of January two years ago.
// The second counts the opportunities closed each year (`QueryAggregate.Count`), with a line for
// those won and one for those lost.

const STRINGS_BASE = 'components.PowerPortalsPro.Demo.Client.Customizations.Pages.Demos.ChartDemos.LineChartShowcaseMainDemo';

const useStyles = makeStyles({
  root: {
    display: 'flex',
    flexDirection: 'column',
    rowGap: tokens.spacingVerticalXL,
  },
});

export function LineChartShowcaseMainSample() {
  const styles = useStyles();
  const t = useT();

  const wonRevenueByMonth = useMemo(
    () =>
      new AggregateDataverseChartDataSource({
        tableName: 'opportunity',
        groupByColumn: 'actualclosedate',
        groupByDateGrouping: DateGrouping.MonthOfYear,
        seriesDateGrouping: DateGrouping.Year,
        aggregateColumn: 'estimatedvalue',
        aggregate: QueryAggregate.Sum,
        // Won, and closed this year or in the two years before it.
        filterXml: `<filter><condition attribute='statecode' operator='eq' value='1' /><condition attribute='actualclosedate' operator='on-or-after' value='${new Date().getFullYear() - 2}-01-01' /></filter>`,
      }),
    [],
  );

  const closedByYear = useMemo(
    () =>
      new AggregateDataverseChartDataSource({
        tableName: 'opportunity',
        groupByColumn: 'actualclosedate',
        groupByDateGrouping: DateGrouping.Year,
        seriesColumn: 'statecode',
        aggregateColumn: 'opportunityid',
        aggregate: QueryAggregate.Count,
        filterXml: "<filter><condition attribute='statecode' operator='ne' value='0' /></filter>",
      }),
    [],
  );

  return (
    <div className={styles.root}>
      <DataverseChart
        dataSource={wonRevenueByMonth}
        type={ChartType.Line}
        title={t(`${STRINGS_BASE}.won-by-month-title`)}
        yAxisPrefix="$"
        height="380px"
      />
      <DataverseChart
        dataSource={closedByYear}
        type={ChartType.Line}
        title={t(`${STRINGS_BASE}.closed-by-year-title`)}
        height="380px"
      />
    </div>
  );
}
